/* eslint-disable react-hooks/exhaustive-deps */
import CommonFormBuilder from "@/app/components/common-form-builder/CommonFormBuilder";
import React, { useEffect, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import DisabledMethodMSg from "../../checkout-error-messages/DisabledMethodMSg";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import {
  FieldSectionTypes,
  FieldTypes,
  IField,
} from "@/api/AppApi/services/builder/interfaces/interfaces";
import { RecievingFields } from "../receiving-settings-helpers/helpers";
import { useAtom } from "jotai";
import { receivingSettingsAtom } from "@/hooks/receivingHeaderAtom";
import { IKeyValue } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { useGetUserLocation } from "@/api/AppApi/services/cart";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface props {
  form: UseFormReturn<FieldValues, any>;
}

const GuestAddressSection: React.FC<props> = ({ form }) => {
  const getCompany = useGetCompanyQuery();
  const countries = getCompany?.data?.result?.countries;
  const [receivingSetting] = useAtom(receivingSettingsAtom);
  const getUserLocation = useGetUserLocation({});
  const userLocationCode = getUserLocation?.data?.country_code;
  const shipingSettings = getCompany?.data?.result?.shipping_settings;
  const t = useTranslation();
  const defaultAddressFields: IField[] = [
    {
      type: "field",
      configurations: {
        title: t.country,
        hint: t.enter_country,
        key: RecievingFields.counteryField,
        section: FieldSectionTypes.address,
        type: FieldTypes.select,
        is_required: true,
        is_extra: false,
        parent_key: null,
        options_url: null,
        multi_lang: false,
      },
      value: null,
      data: [],
    },
    {
      type: "field",
      configurations: {
        title: t.city,
        hint: t.enter_city,
        key: RecievingFields.cityField,
        section: FieldSectionTypes.address,
        type: FieldTypes.select,
        is_required: true,
        is_extra: false,
        parent_key: "address(country_id",
        options_url: "/cities",
        multi_lang: false,
      },
      value: null,
      data: [],
    },
    {
      type: "field",
      configurations: {
        title: t.area,
        hint: t.enter_area,
        key: RecievingFields.areaField,
        section: FieldSectionTypes.address,
        type: FieldTypes.select,
        is_required: true,
        is_extra: false,
        parent_key: "address(city_id",
        options_url: "/areas",
        multi_lang: false,
      },
      value: null,
      data: [],
    },
  ];
  const [addressFields, setAddressFields] =
    useState<IField[]>(defaultAddressFields);

  useEffect(() => {
    setAddressFields((addressFields) => [
      ...addressFields.map((field) => ({
        ...field,
        data: (field.configurations.key === RecievingFields.counteryField
          ? countries?.map(
              (country): IKeyValue => ({
                key: country.id?.toString()!,
                value: country?.name!,
              }),
            )
          : null)!,
      })),
    ]);
  }, [countries]);
  useEffect(() => {
    if (!userLocationCode) return;
    form.setValue(
      RecievingFields.counteryField,
      userLocationCode
        ? {
            key:
              countries
                ?.find((country) => country?.code === userLocationCode)
                ?.id.toString() ?? null,
            value:
              countries?.find((country) => country?.code === userLocationCode)
                ?.name ?? null,
          }
        : null,
    );
  }, [userLocationCode]);
  useEffect(() => {
    if (receivingSetting) {
      form.reset({
        ...form.getValues(),
        [RecievingFields.areaField]: receivingSetting?.address?.area_id,
        [RecievingFields.cityField]: receivingSetting?.address?.city_id,
        [RecievingFields.counteryField]: receivingSetting?.address?.country_id,
      });
    }
  }, [receivingSetting, countries]);

  return (
    <div className="d-flex gap-2 flex-column pb-5">
      {shipingSettings?.enable_shipping ? (
        <>
          {addressFields?.map((field) => (
            <CommonFormBuilder
              key={field.configurations.key}
              field={field}
              form={form}
              isGetKeyValue
              isSearchDropDown
              customOnChange={(_) => {
                if (
                  field.configurations.key === RecievingFields.counteryField
                ) {
                  form.setValue(RecievingFields.cityField, null);
                  form.setValue(RecievingFields.areaField, null);
                }
              }}
            />
          ))}
        </>
      ) : (
        <DisabledMethodMSg
          message={shipingSettings?.shipping_not_available_message!}
        />
      )}
    </div>
  );
};

export default GuestAddressSection;
